var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-560.000000, -1144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(561.000000, 1144.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#138057",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.875 8.1375 4.95833333 11.8125 13.125 2.625"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckMark);
export default __webpack_public_path__ + "static/media/green-check-mark.b3fd63eb9fe9ee4d23cf9aa7822c78b3.svg";
export { ForwardRef as ReactComponent };